// extracted by mini-css-extract-plugin
export default {"tableRow":"ClientPalletBalanceTableRow_tableRow__8TrgH","totalSum":"ClientPalletBalanceTableRow_totalSum__CZd8O"};